module.exports = __webpack_public_path__ + "284acc4948564f445f5fba19db886c2d.gif";